import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Slide, { SlideProps } from "@mui/material/Slide";
import Fade from "@mui/material/Fade";
import { TransitionProps } from "@mui/material/transitions";
import { Box, Typography } from "@mui/material";

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

type CustomSnackbarProps = {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  autoHideDuration?: number;
  backgroundColor?: string;
  Transition?: React.ComponentType<
    TransitionProps & { children: React.ReactElement<any, any> }
  >;
};

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  open,
  title,
  message,
  onClose,
  autoHideDuration = 2000,
  backgroundColor = "#ffff",
  Transition = Fade,
}) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      TransitionComponent={SlideTransition}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Box
        sx={{
          backgroundColor,
          p: 2,
          borderRadius: "6px",

          minWidth: "350px",
          boxShadow: "0px 2px 3px 0px #dcdcdc",

          fontSize: "14px",
        }}
      >
        {title && (
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "600",
              mb: 0.5,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#020817",
            }}
          >
            {title}
          </Typography>
        )}
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#020817",
          }}
        >
          {message}
        </Typography>
      </Box>
    </Snackbar>
  );
};

export default CustomSnackbar;
